import { flightsLocalStore } from "./browser-storage.js";
const STORAGE_KEY = "flights-dev-overrides";
const storage = flightsLocalStore || undefined;
export const getAll = () => {
    return storage?.get(STORAGE_KEY) || {};
};
export const setAll = (data) => {
    return storage?.set(STORAGE_KEY, data);
};
